"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubscriptionProductTypeTrads = void 0;
exports.ESubscriptionProductTypeTrads = {
    pleine_propriete: "Pleine propriété",
    nue_propriete: "Nue-propriété",
    usufruit: "Usufruit",
};
